import { render, staticRenderFns } from "./DeleteDepartment.vue?vue&type=template&id=16674d1e&"
import script from "./DeleteDepartment.vue?vue&type=script&lang=js&"
export * from "./DeleteDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports